import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/material'
import Radio from 'packages/ui/Radio'

import Select from 'components/global/CUK/AsyncSelect/Select';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';

import { FILTER_PROJECTS_STATUS, CATEGORIES_PROJECT } from '../constants'
import { useProjectsFilters } from '../store'

const Services = () => {
  const [filters, setFilters] = useProjectsFilters()
  const {t} = useTranslation()
  const choices = useMemo(() => {
    return Object.keys(CATEGORIES_PROJECT).map(category => ({
      id: category,
      value: category,
      label: t(`projects.services.category.${category}`)
    }))
  }, [])
  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={choices}
      mainField="label"
      placeholder={t('projects.filters.services')}
      components={{
        Option: (props) => {
          return (
            <OptionMultiCount {...props} value={props.data}  />
          );
        }
      }}
      onChange={(values) => {
        setFilters(prev => ({...prev, services: values.map(({value}) => value)}))
      }}
      value={choices.filter(
        (choice) => filters.services.includes(choice.value)
      )}
    />
  );
}
export const Filters = () => {
  const [filters, setFilters] = useProjectsFilters()
  const { t } = useTranslation()
  return (
    <Stack direction={'row'} gap={2}>
      <Services />
      <Radio
        checked={filters.state === null}
        onChange={() => {
          setFilters(prev => ({...prev, state: null}))
        }}
        label={t('projects.table.status.all')}
      />
      {
        FILTER_PROJECTS_STATUS.map(status => (
          <Radio
            key={status}
            checked={status === filters.state}
            onChange={() => {
              // @ts-expect-error tofix
              setFilters(prev => ({...prev, state: status}))
            }}
            label={t(`projects.table.status.${status}`)}
          />
        ))
      }
    </Stack>
  )
}


export default Filters